import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pro-list',
  templateUrl: './pro-list.component.html',
  styleUrls: ['./pro-list.component.scss']
})
export class ProListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
